
import { Routes, Route, } from "react-router-dom";

import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/es";


import { PrivateCuadroMandoProvider } from "./systems/cuadro_mando/context/AuthCuadroMandoContext";
import { AuthEgresadosProvider } from "./systems/egresados/context/AuthEgresadosProvider";
//import { EmpresaProvider } from "./systems/egresados/context/Empresa/EmpresaProvider";

import EgresadosRoutes from "./systems/egresados/routers/EgresadosRouters";
//import EmpresaRoutes from "./systems/egresados/routers/EmpresasRouters";
import PrivateCMI from "./systems/cuadro_mando/routers/PrivateCMIRoutes";
import WelcomeMiConalepLayout from "./layout/WelcomeMiConalepLayout";


dayjs.extend(localizedFormat);
dayjs.locale("es");

function App(props) {
  return (
    <div className="App">
      <Routes>
        <Route index element={<WelcomeMiConalepLayout />} />
        <Route path="/egresados/*" element={<AuthEgresadosProvider><EgresadosRoutes /></AuthEgresadosProvider>} />
        <Route path="/*" element={<PrivateCuadroMandoProvider><PrivateCMI {...props} /></PrivateCuadroMandoProvider>} />
        {/* <Route path="/empresas/*" element={<EmpresaProvider> <EmpresaRoutes  /> </EmpresaProvider>} /> */}
      </Routes>
    </div>
  );
}
export default App; 